// OTTO EU

import React from 'react';
import CrudListContainerBase from './Base';
export default class CrudListContainer extends CrudListContainerBase {
  constructor(props) {
    let pageType = '';
    if (props.match) {
      pageType = props.match.params.type;
    }
    super(props);
    this.additionalContent = () => '';
    this.getAddGroups = () => [];
    this.createButtonType = () => '';
    this.getAddText = () => this.props.t('buttons.createType', {
      type: this.props.t("".concat(this.createButtonType(), ".modelType"))
    });
    this.getEditGroups = () => [];
    this.getFormTag = () => '';
    // component add/edit form
    this.getColumns = () => [];
    this.getListApi = () => '';
    this.getApiVersion = () => 1;
    this.getListParams = () => ({});
    this.getQueryName = () => '';
    this.sendAsData = () => false;
    this.getStorageName = () => null;
    this.getTrProps = () => '';
    this.getPageTitle = () => '';
    this.getPageSubtitle = () => '';
    this.indexTable = () => this.basicTable();
    this.refreshAfterUpdate = () => this.getList();
    this.loadOnMount = () => this.getList();
    this.getWidthCenter = () => 6;
    this.getWidthLeft = () => 3;
    this.getWidthRight = () => 3;
    this.canDownloadCsv = () => true;
    this.auditLogModelType = () => '';
    this.state = {
      userGroups: [],
      data: [],
      loading: true,
      showModal: false,
      editItem: null,
      tableOpen: false
    };
    this.tableRef = React.createRef();
    this.innerTableRef = React.createRef();
  }
}